import { render } from "./DialogShareCode.vue?vue&type=template&id=4ebc2fb5&scoped=true&ts=true"
import script from "./DialogShareCode.vue?vue&type=script&lang=ts"
export * from "./DialogShareCode.vue?vue&type=script&lang=ts"

import "./DialogShareCode.vue?vue&type=style&index=0&id=4ebc2fb5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebc2fb5"]])

export default __exports__